<template>
  <el-table-column
    :label="label"
    :prop="prop"
    :width="width"
    :min-width="minWidth"
    :align="align"
    :fixed="fixed"
    :render-header="labelRender"
  >
    <template slot-scope="scope">
      <!-- 操作区域 -->
      <div v-if="handle">
        <slot :row="scope.row" :index="scope.$index" />
      </div>
      <div v-else>
        <!--{{ filedRules }}-->
        <!-- text -->
        <span v-if="!scope.row.editable">{{
          formatText(scope.row[prop], scope.row["editable"])
        }}</span>
        <!-- input -->
        <el-form v-else>
          <!-- text -->
          <el-form-item :prop="prop" v-if="inputType === 'text'">
            <!--<el-input v-model="form.inputVal" size="mini" clearable="" />-->
            <el-input v-model="scope.row[prop]" size="mini" clearable="" />
          </el-form-item>
          <!-- select -->
          <el-form-item :prop="prop" v-else-if="inputType === 'select'">
            <el-select v-model="scope.row[prop]" size="mini" clearable="">
              <el-option
                v-for="item in selectList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </el-table-column>
</template>

<script>
export default {
  name: "lea-edit-table-column",
  inject: ["rules"],
  props: {
    label: {
      type: String,
      default: ""
    },
    prop: {
      type: String
    },
    fixed: String,
    width: String,
    minWidth: String,
    align: String,
    // 编辑框的类型
    inputType: {
      type: String,
      default: "text"
    },
    // 下拉框数据
    selectList: {
      type: Array,
      default: () => []
    },
    // header提示信息
    tip: String,
    // 是否是操作按钮组
    handle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rule: this.rules[this.prop] || [],
      filedRules: {},
      form: {
        inputVal: ""
      }
    };
  },
  computed: {
    // 是否选项类别
    isList() {
      return this.inputType === "select" || this.inputType === "radio";
    }
    // 规则
    // filedRules() {
    //   // console.log(this.rules[this.prop]);
    //   let rules = {};
    //   rules[this.prop] = this.rules[this.prop];
    //   console.log(rules);
    //   return rules;
    // }
  },
  methods: {
    // 自定义头部的render函数
    labelRender(createElement, { column }) {
      // console.log(column, $index, "index");
      // 渲染队列
      let renders = [];

      // 是否有必填项
      let propRules = this.rules[this.prop];
      let isRequiredRule =
        propRules && propRules.some(item => item["required"]);

      // 装载渲染队列
      if (isRequiredRule) {
        renders.push(createElement("span", { class: "required" }, "*"));
      }
      renders.push(createElement("span", [`${column.label}`]));
      if (this.tip) {
        let tip = this.tip;
        renders.push(
          createElement(
            "el-tooltip",
            {
              attrs: {
                content: tip,
                placement: "top"
              }
            },
            // 添加span节点 定义class为el-icon-caret-left tableHeaderIcon1
            [
              createElement("span", [
                createElement("span", {
                  attrs: { class: "el-icon-info tableHeaderIcon1" }
                })
              ])
            ]
          )
        );
      }

      return renders;
    },

    // 格式化列表数组文字
    formatText(text, editable) {
      if (!editable && this.isList) {
        let filterArr = this.selectList.filter(item => item.value === text);
        text = filterArr.length === 0 ? "" : filterArr[0]["label"];
      }

      return text;
    }
  },
  created() {
    this.$set(this.filedRules, this.prop, this.rules[this.prop]);
  }
};
</script>

<style>
.tableHeaderIcon1 {
  margin-left: 4px;
  color: #bbb;
  font-size: 12px;
}
.required {
  padding-right: 4px;
  color: #f00;
}
</style>
